import { styled } from "@mui/material";
import { Link } from "react-router-dom";
// import RotoGPTLogo from "../../assets/RotoGPT.png";
// import { ReactComponent as RotoGPTLogo } from "../../assets/RotoGPTLogo.svg";
import RotoGPTLogoBlack from "../../assets/RotoGPTblack.png";

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        margin: 0 auto;
        font-weight: ${theme.typography.fontWeightBold};
`
);

// const StyledSVG = styled(RotoGPTLogo)`
//   width: 48px;
//   height: 20px;
// `;

function BlackLogo() {
  return (
    <LogoWrapper to="">
      {/* <img src={`${process.env.PUBLIC_URL}/RotoGPT.png`} style={{ width: "48px", height: "20px" }} alt="RotoGPT logo" /> */}
      <img src={RotoGPTLogoBlack} style={{ width: "48px", height: "20px" }} alt="RotoGPT Black logo" />
      {/* <StyledSVG /> */}
    </LogoWrapper>
  );
}

export default BlackLogo;
